// extracted by mini-css-extract-plugin
export default {"root":"ConfiguratorFilterLayout_root__JdGuw"};